import { cbi_waste_container_size_unit_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateCbiWasteContainerSizeUnitEnum = (enumValue: cbi_waste_container_size_unit_enum) => {
  switch (enumValue) {
    case cbi_waste_container_size_unit_enum.L:
      return <Trans i18nKey="Enum_CbiWasteContainerSizeUnitEnum-L" />;
    case cbi_waste_container_size_unit_enum.M3:
      return <Trans i18nKey="Enum_CbiWasteContainerSizeUnitEnum-M3" />;
  }
};

export const translateCbiWasteContainerSizeUnitEnum_dynamic = (enumValue: cbi_waste_container_size_unit_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case cbi_waste_container_size_unit_enum.L:
      return t('Enum_CbiWasteContainerSizeUnitEnum-L');
    case cbi_waste_container_size_unit_enum.M3:
      return t('Enum_CbiWasteContainerSizeUnitEnum-M3');
  }
};
